import type { WeeklyCalculatorFormValues } from "../types/form"

type WeeklyFieldName = keyof WeeklyCalculatorFormValues

type WeeklyBaseFieldDefinition = {
  name: WeeklyFieldName
  labelKey: string
  placeholderKey?: string
}

type WeeklySelectOptionDefinition = {
  labelKey: string
  value: string
  disabled?: boolean
  helperKey?: string
}

type WeeklySelectFieldDefinition = WeeklyBaseFieldDefinition & {
  kind: "select"
  options: ReadonlyArray<WeeklySelectOptionDefinition>
}

export const weekStartOptions = [
  { labelKey: "form.weekStartOptions.monday", value: "monday" },
  { labelKey: "form.weekStartOptions.saturday", value: "saturday" },
  { labelKey: "form.weekStartOptions.sunday", value: "sunday" },
] as const

export const hoursOpenPerDayOptions = [
  { labelKey: "form.hoursOpenPerDayOptions.8", value: "8" },
  { labelKey: "form.hoursOpenPerDayOptions.9", value: "9" },
  { labelKey: "form.hoursOpenPerDayOptions.10", value: "10" },
  { labelKey: "form.hoursOpenPerDayOptions.12", value: "12" },
  { labelKey: "form.hoursOpenPerDayOptions.24", value: "24" },
] as const

export const WEEKLY_SPECIFIC_FIELDS: WeeklySelectFieldDefinition[] = [
  {
    name: "hoursOpenPerDay",
    labelKey: "form.fields.hoursOpenPerDay.label",
    placeholderKey: "form.placeholders.hoursOpenPerDay",
    kind: "select",
    options: hoursOpenPerDayOptions,
  },
]

export const WEEKLY_ADVANCED_FIELDS: WeeklySelectFieldDefinition[] = [
  {
    name: "weekStart",
    labelKey: "form.fields.weekStart.label",
    placeholderKey: "form.placeholders.weekStart",
    kind: "select",
    options: weekStartOptions,
  },
]

export const DAY_DISTRIBUTION_FIELDS = [
  { name: "distributionMonday" as const, labelKey: "form.fields.distribution.monday" },
  { name: "distributionTuesday" as const, labelKey: "form.fields.distribution.tuesday" },
  { name: "distributionWednesday" as const, labelKey: "form.fields.distribution.wednesday" },
  { name: "distributionThursday" as const, labelKey: "form.fields.distribution.thursday" },
  { name: "distributionFriday" as const, labelKey: "form.fields.distribution.friday" },
  { name: "distributionSaturday" as const, labelKey: "form.fields.distribution.saturday" },
  { name: "distributionSunday" as const, labelKey: "form.fields.distribution.sunday" },
] as const
